<template>
  <div class="order-container">

    <template v-if="!this.store.getters['customer/isLoggedIn']">
      <h5 class="font-weight-600 p-2 m-0">{{ $t('responsible_person_info') }}</h5>
    </template>

    <form class="order-container__form">
      <div class="d-flex flex-column">

        <template v-if="!this.store.getters['customer/isLoggedIn']">
          <template v-for="input in form.inputs">
            <template v-if="input.key === 'isCompanyOrder'">
              <div class="d-flex checkbox-company">
                <CheckBoxComponent
                    id="isCompanyOrder"
                    name="isCompanyOrder"
                    @onClick="input.value = !input.value; input.value ? onIsCompanyOrderToggle() : null;"
                    :state="input.value">
                  <template #checkbox-text>
                    <label class="font-big font-weight-400 check-box-label" for="isCompanyOrder">{{
                        $t('buying_company')
                      }}</label>
                  </template>
                </CheckBoxComponent>
              </div>
              <div v-if="!input.validation.state"
                   :class="{'error-color': !input.validation.state}"
                   class="font-small">
                {{ $t(input.validation.message) }}
              </div>
            </template>
          </template>

          <template v-for="input in form.inputs">
            <template v-if="input.dataType === InputDataTypes.TEXT">
              <InputComponent
                  :name-input="input.name"
                  :data-type="input.dataType"
                  :placeholder="$t(input.placeholder)"
                  v-model:data="input.value"
                  :msg="input.validation"></InputComponent>
            </template>
          </template>

        </template>

        <template v-else>
          <UserWrapperComponent></UserWrapperComponent>
        </template>

        <div class="d-flex flex-column order-3">
          <OrderPaymentDataWrapperComponent :data="{
            duration,
            distance,
            price
          }"></OrderPaymentDataWrapperComponent>
        </div>

        <template v-for="input in mainForm.inputs">
          <template v-if="input.key === 'isRulesAgreement'">
            <div class="d-flex checkbox-rule-agreement order-4">
              <CheckBoxComponent
                  @onClick="input.value = !input.value"
                  :state="input.value"
                  id="isRuleAgreement"
                  name="isRuleAgreement"
                  class="">
                <template #checkbox-text>
                  <div class="font-big font-weight-400 check-box-label">
                    <label for="isRuleAgreement" class="ms-0 me-1">
                      {{ $t('i_agree_with_the') }}
                    </label>
                    <span
                        class="rule-agreement"
                        data-bs-toggle="modal" data-bs-target="#purchaseDeclarationModal" href="#" target="_blank">
                      {{ $t('rules_more') }}
                    </span>
                  </div>
                </template>
              </CheckBoxComponent>
            </div>
            <div v-if="!input.validation.state"
                 :class="{'error-color': !input.validation.state}"
                 class="font-small order-4">
              {{ $t(input.validation.message) }}
            </div>
          </template>
        </template>

        <!-- MAIN VALIDATION MESSAGES-->
        <template v-for="(prop, key) in mainValidationMessages">
          <div
              v-if="!prop.isValid"
              :class="{'error-color': !prop.isValid}"
              class="font-small order-4"
              :key="key"
          >
            {{ $t(prop.message) }}
          </div>
        </template>

        <!-- BACKEND VALIDATION ERRORS-->
        <template v-for="error in backendValidationErrors">
          <div class="font-small order-4 error-color">
            {{ $t(error) }}
          </div>
        </template>

        <template v-if="!orderProcessing">
          <ButtonComponent class="order-form-submit-button order-4" v-on:click.prevent="orderSubmit">
            <template #btnContent>
              {{ ! isSimpleOrder ? $t('pay_order') : $t('order_order')}}
            </template>
          </ButtonComponent>
        </template>
        <template v-else>
          <ButtonComponent class="order-form-submit-button order-4" disabled="disabled">
            <template #btnContent>
              <span class="loader"></span>
            </template>
          </ButtonComponent>
        </template>

<!--        <button class="order-form-submit-button order-4" v-on:click.prevent="orderSubmit">-->
<!--          {{ $t('pay_order') }}-->
<!--        </button>-->

      </div>
    </form>
  </div>

  <Teleport to="body">
    <ModalComponent
        :is-main-modal="false"
        :show-link="false"
        :id="'rule-agreement'"
        :z-index-custom="'z-index-custom-0'"
        :backdrop="'custom-modal-backdrop-0'"
        :body-overflow="'body-overflow'">
      <template #body-content>
        <div class="rule-agreement-modal d-flex justify-content-center"><h5>{{ $t('rules') }}</h5></div>
      </template>
    </ModalComponent>
  </Teleport>

  <Teleport to="body">
    <ModalComponent
        :is-main-modal="false"
        :show-link="false"
        :id="'buying-company'"
        :z-index-custom="'z-index-custom-0'"
        :backdrop="'custom-modal-backdrop-0'"
        :body-overflow="'body-overflow'">
      <template #body-content>
        <div class="company-form d-flex justify-content-center">
          <div class="company-form__container d-flex flex-column align-items-center col-9">
            <h5>{{ $t('company_data') }}</h5>
            <InputComponent v-for="input in companyForm.inputs"
                            class="col-12"
                            :name-input="input.name"
                            :data-type="input.dataType"
                            :placeholder="$t(input.placeholder)"
                            v-model:data="input.value"
                            :msg="input.validation"></InputComponent>

            <ButtonComponent id="submitButtonCompany" class="col-12 order-form-submit-button"
                             v-on:click="submitCompanyForm">
              <template #btnContent>
                {{ $t('submit') }}
              </template>
            </ButtonComponent>

          </div>
        </div>
      </template>
    </ModalComponent>
  </Teleport>
</template>

<script lang="ts">
import './OrderForm.scss';
import {defineComponent} from "vue";

// @ts-ignore
import UserWrapperComponent from "./userWrapper/UserWrapperComponent.vue";
// @ts-ignore
import ModalComponent from "../../modal/ModalComponent.vue";
// @ts-ignore
import InputComponent from "../../input/InputComponent.vue";
// @ts-ignore
import ButtonComponent from "../../Button/ButtonComponent.vue";
// @ts-ignore
import CheckBoxComponent from "../../CheckBox/CheckBoxComponent.vue";
// @ts-ignore
import OrderPaymentDataWrapperComponent from "../../vehicleOrderTemplateContainers/orderPaymentDataWrapper/OrderPaymentDataWrapperComponent.vue";

import {mapState, useStore} from "vuex";
import FormValidationService from "../../../services/formValidationService";
import type {IInput} from "../../../interfaces/IInput.interface";
import type {IForm} from "../../../interfaces/IForm.interface";
import {InputDataTypes} from "../../../interfaces/enums/InputDataTypes.enum";
import {modalEvents} from '../../../helpers/modalEvents';
import axios from "axios";
import apiService from "../../../services/apiService";
import {ServiceTypes} from "../../../interfaces/enums/ServiceTypes.enum";
import {routesConst} from "../../../routes";
import {axiosHelpers} from "../../../helpers/axiosHelpers";
import type {IOrderState} from "@/store/states/IOrderState.interface";
import {PaymentMethods} from "../../../interfaces/enums/PaymentMethods.enum";
import type {IVehicleState} from "@/store/states/IVehicleState.interface";
import type {IOrderFalseRoundTripState} from "@/store/states/IOrderFalseRoundTripState.interface";

export default defineComponent({
  name: 'OrderFormComponent',
  components: {
    ButtonComponent,
    InputComponent,
    ModalComponent,
    UserWrapperComponent,
    CheckBoxComponent,
    OrderPaymentDataWrapperComponent
  },
  props: {
      isLoading: {
          type: Boolean,
          required: false,
      },

  },
  data(this:any) {
    return {
      InputDataTypes: InputDataTypes,

      duration: {
        totalInSec: 0,
        hours: 0,
        minutes: 0
      },
      distance: <number|null>null,
      price: 0,

      companyForm: <IForm>{
        isValid: false,
        inputs: <IInput[]>[
          <IInput>{
            key: 'companyName', // NOTE prop binded with store
            name: 'company_name',
            dataType: InputDataTypes.TEXT,
            placeholder: 'company_name',
            // @ts-ignore
            value: this.store.state.order.companyName ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'please_enter_valid_company_name'}
              }
            }
          },
          <IInput>{
            key: 'companyCode', // NOTE prop binded with store
            name: 'company_code',
            dataType: InputDataTypes.TEXT,
            placeholder: 'company_code',
            // @ts-ignore
            value: this.store.state.order.companyCode ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'please_enter_valid_company_code'}
              }
            }
          },
          <IInput>{
            key: 'companyTaxCode', // NOTE prop binded with store
            name: 'vat_code',
            dataType: InputDataTypes.TEXT,
            placeholder: 'vat_code',
            // @ts-ignore
            value: this.store.state.order.companyTaxCode ?? null,
            validation: {
              state: true,
              message: null,
              rules: {}
            }
          },
          <IInput>{
            key: 'companyAddress', // NOTE prop binded with store
            name: 'company_address',
            dataType: InputDataTypes.TEXT,
            placeholder: 'company_address',
            // @ts-ignore
            value: this.store.state.order.companyAddress ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'please_enter_valid_company_address'}
              }
            }
          },
        ]
      },
      form: <IForm>{
        isValid: false,
        inputs: <IInput[]>[
          <IInput>{
            key: 'isCompanyOrder', // NOTE prop binded with store
            name: 'isCompanyOrder',
            dataType: InputDataTypes.CHECKBOX,
            // @ts-ignore
            value: this.store.state.order.isCompanyOrder ?? null,
            validation: {
              state: true,
              message: null,
              rules: {}
            }
          },
          <IInput>{
            key: 'fullName', // NOTE prop binded with store
            name: 'fullName',
            dataType: InputDataTypes.TEXT,
            placeholder: 'first_last_name',
            // @ts-ignore
            value: this.store.state.order.fullName ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'Please_Enter_your_full_name'}
              }
            }
          },
          <IInput>{
            key: 'phoneNumber', // NOTE prop binded with store
            name: 'phoneNumber',
            dataType: InputDataTypes.TEXT,
            placeholder: 'phone_nr',
            // @ts-ignore
            value: this.store.state.order.phoneNumber ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'Please_Enter_your_phone_number'},
                length: {gt: 6, message: 'Please_Enter_longer_than_6_digits'}
              }
            }
          },
          <IInput>{
            key: 'email', // NOTE prop binded with store
            name: 'email',
            dataType: InputDataTypes.TEXT,
            placeholder: 'e_mail',
            // @ts-ignore
            value: this.store.state.order.email ?? null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'Please_Enter_your_email'},
                email: {message: 'Please_Enter_your_valid_email'}
              }
            }
          },
        ]
      },
      mainForm: <IForm>{
        isValid: false,
        inputs: <IInput[]>[
          <IInput>{
            key: 'isRulesAgreement', // NOTE prop binded with store
            name: 'isRulesAgreement',
            dataType: InputDataTypes.CHECKBOX,
            value: false, // Not from store to force on load -> false
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'Please_check_to_agree_with_the_rules'}
              }
            }
          }
        ]
      },

      mainValidationMessages: {
        isCompanyFormValid: {
          isValid: true,
          message: 'company_order_checked_but_company_order_form_is_not_valid',
        },

        isCustomerFormValid: {
          isValid: true,
          message: 'customer_form_is_not_valid',
        },
      },
      backendValidationErrors: <string[]>[],
      orderProcessing: false,
      isSimpleOrder: false,
    }
  },
  setup() {
    const store = useStore();

    return {
      store,
    };
  },

  computed: {
    ...mapState<IOrderState>('order', {
      orderStatePaymentMethod: (state: IOrderState) => state.paymentMethod,
    }),
    ...mapState<IOrderState>('vehicle', {
      vehicleStateSelectedId: (state: IVehicleState) => state.selectedId,
    }),
    ...mapState<IOrderFalseRoundTripState>('orderFalseRoundTrip', {
        transportations: (state: IOrderFalseRoundTripState) => state.transportations,
    }),
  },

  watch: {
    orderStatePaymentMethod: {
      handler(this:any, val, oldVal) {
        this.handleOrderStatePaymentMethodChange(val, oldVal);
      },
      immediate: true
    },
    vehicleStateSelectedId: {
      handler(val, oldVal) {
        if (val !== oldVal) {
          this.triggerPageDataPreparation();
        }
      },
    },
    isLoading: {
        handler(val, oldVal) {
            if (!val) {
                this.triggerPageDataPreparation();
            }
        },
        immediate: true
    }
  },

  methods: {
    handleOrderStatePaymentMethodChange(this:any, val, oldVal): void {
      switch (val) {
        case PaymentMethods.CASH:
        case PaymentMethods.BANK_TRANSFER:
        case PaymentMethods.CREDIT_CONTRACT:
          this.isSimpleOrder = true;
          break;

        default:
          this.isSimpleOrder = false;
          break;
      }
    },

    onIsCompanyOrderToggle(this:any, event) {
      modalEvents.openModal(event, {id: 'buying-company'}, 'custom-modal-backdrop-0');
    },

    setData(this:any, payload) {
      // Set values if form is valid, if not - reset store company info to null
      const formData = payload.map((input: IInput) => {
        return {prop: input.key, value: input.value};
      });

      this.store.dispatch('order/updateFormData', formData);
    },

    submitCompanyForm(this:any): void {
      const isValid = FormValidationService.validate(this.companyForm.inputs);
      this.companyForm.isValid = isValid;
      this.store.dispatch('order/setIsCompanyFormValid', isValid);

      if (! isValid) {
        return;
      }

      this.setData(this.companyForm.inputs);
      modalEvents.closeModal({id: 'buying-company', backdrop: 'custom-modal-backdrop-0', bodyOverflow: 'body-overflow'});

    },

    orderSubmit(this:any): void {
      if (this.orderProcessing) {
        return;
      }
      this.orderProcessing = true;

      let isValid = true;

      // Validate
      if (! this.store.getters['customer/isLoggedIn']) {
        isValid = FormValidationService.validate(this.form.inputs);
      }

      if (isValid) {
        isValid = FormValidationService.validate(this.mainForm.inputs);
      }

      this.form.isValid = isValid;
      this.store.dispatch('order/setIsCustomerFormValid', isValid);

      this.setData([...this.form.inputs].concat([...this.mainForm.inputs]));


      // reset main validation messages
      for (const prop in this.mainValidationMessages) {
        this.mainValidationMessages[prop].isValid = true;
      }


      // Guest user validation
      if (! this.store.getters["customer/isLoggedIn"]) {
        if (this.store.state.order.isCompanyOrder && !this.store.state.order.isCompanyFormValid) {
          this.mainValidationMessages.isCompanyFormValid.isValid = false;

          this.orderProcessing = false;
          return;
        }

        if (!this.store.state.order.isCustomerFormValid) {
          this.mainValidationMessages.isCustomerFormValid.isValid = false;

          this.orderProcessing = false;
          return;
        }
      }

      if (! isValid) {
        this.orderProcessing = false;
        return;
      }

      // Prepare data for post
      let data = <object>{
        vehicleId: null,
        mainFormData: null,
        serviceType: this.store.state.order.serviceType,
        withDriver: this.store.state.order.withDriver,
        roundTrip: this.store.state.order.roundTrip,
        isCompanyOrder: this.store.state.order.isCompanyOrder,
        customerFormData: <any>null,
        companyFormData: <any>null,
        paymentData: {
          isInvoiceNeeded: this.store.state.order.isInvoiceNeeded,
          paymentMethod: this.store.state.order.paymentMethod,
        },
        isRulesAgreement: this.store.state.order.isRulesAgreement
      };

      switch (this.store.state.order.serviceType) {
        case ServiceTypes.SERVICE_RENT:
          data = {...data, vehicleId: this.store.state.vehicle.selectedVehicle.id};

          if (this.store.state.order.withDriver) {
            data = {
              ...data,
              mainFormData: {...this.store.state.orderTrueDriver},
              dateFormData: {...this.store.state.orderTrueDriverDates}
            };
          } else {
            data = {
              ...data,
              mainFormData: {...this.store.state.orderFalseDriver}
            };
          }
          break;

        case ServiceTypes.SERVICE_TRANSPORTATION:
          if (this.store.state.order.roundTrip) {
            const state = this.store.state.orderTrueRoundTrip;
            const forwardTicket = state.forwardTicket;
            const backTicket = state.backTicket;

            data = {
              ...data,
              mainFormData: {
                tripPassengers: state.tripPassengers,
                forwardTicket: {
                  // ...state.forwardTicket,
                  transportationId: forwardTicket.transportationId,
                  isSelected: forwardTicket.isSelected,
                  data: forwardTicket.data,
                  tripDate: forwardTicket.tripDate,
                  pickUp: {
                    id: forwardTicket.pickUp.id,
                    city: forwardTicket.pickUp.address_to_show + ', ' + forwardTicket.pickUp.city,
                    specified_address: forwardTicket.pickup_specified_address, 
                    note: forwardTicket.pickup_note
                  },
                  dropOff: {
                    id: forwardTicket.dropOff.id,
                    city: forwardTicket.dropOff.address_to_show + ', ' + forwardTicket.dropOff.city,
                    specified_address: forwardTicket.dropoff_specified_address, 
                    note: forwardTicket.dropoff_note
                  },
                },
                backTicket: {
                  // ...state.backTicket,
                  transportationId: backTicket.transportationId,
                  isSelected: backTicket.isSelected,
                  data: backTicket.data,
                  tripDate: backTicket.tripDate,
                  pickUp: {
                    id: backTicket.pickUp.id,
                    city: backTicket.pickUp.address_to_show + ', ' +  backTicket.pickUp.city,
                    specified_address: backTicket.pickup_specified_address, 
                    note: backTicket.pickup_note
                  },
                  dropOff: {
                    id: backTicket.dropOff.id,
                    city: backTicket.dropOff.address_to_show + ', ' + backTicket.dropOff.city,
                    specified_address: backTicket.dropoff_specified_address, 
                    note: backTicket.dropoff_note
                  },
                }
              }
            }
          } else {
            const state = this.store.state.orderFalseRoundTrip;
            data = {
              ...data,
              mainFormData: {
                pickUp: {
                    id: state.pickUp.id, 
                    city: state.pickUp.address_to_show + ', ' + state.pickUp.city,
                    specified_address: state.pickup_specified_address, 
                    note: state.pickup_note
                },
                dropOff: {
                    id: state.dropOff.id, 
                    city: state.dropOff.address_to_show + ', ' + state.dropOff.city,
                    specified_address: state.dropoff_specified_address, 
                    note: state.dropoff_note
                },
                tripDepartureDate: state.tripDepartureDate,
                tripPassengers: state.tripPassengers,
                transportationId: state.transportationId,
              }
            }
          }
          break;
      }

      // Customer data
      if (!this.store.getters["customer/isLoggedIn"]) {
        data = {
          ...data, customerFormData: {
            fullName: this.store.state.order.fullName,
            phoneNumber: this.store.state.order.phoneNumber,
            email: this.store.state.order.email,
          }
        };

        // Company data
        if (this.store.state.order.isCompanyOrder) {
          data = {
            ...data, companyFormData: {
              companyName: this.store.state.order.companyName,
              companyCode: this.store.state.order.companyCode,
              companyTaxCode: this.store.state.order.companyTaxCode,
              companyAddress: this.store.state.order.companyAddress,
            }
          };
        }
      }

      axios.post(apiService.pageOrderPageEndpoint(), data)
          .then(response => {

            // Instead of using local this.isSimpleOrder to be sure we have to get from backend
            if (response.data.isSimpleOrder) {
              this.$router.push(routesConst.ORDER_REGISTERED);
              return;
            }

            // Redirect to payment provider
            const params = new URLSearchParams({
              'accept_url': new URL(this.$router.resolve({name: routesConst.ORDER_IN_PROGRESS}).href, window.location.origin).href,
              'cancel_url': new URL(this.$router.resolve({name: routesConst.ORDER_FAILED}).href, window.location.origin).href
            });

            const href = response.data.url + '?' + params.toString();

            // Check if url is working correctly it should get back with 302 http code
            axios.get(href)
                .then(response => {
                  this.backendValidationErrors.push('key_loading_error');
                  console.error(response);
                  this.orderProcessing = false;
                })
                .catch(error => {
                  const response = error.response;

                  switch (response.status) {
                    case 0:
                      if (error.code !== "ERR_NETWORK") { // if not CORS -> stop
                        break;
                      }
                    case 302: // If CORS or 302
                      window.location.href = href;

                      return;
                  }
                  this.backendValidationErrors = axiosHelpers.handleAxiosErrors(error, 'key_unprocessable_content');
                  this.orderProcessing = false;
                });
          })
          .catch(error => {
            this.backendValidationErrors = axiosHelpers.handleAxiosErrors(error, 'key_unprocessable_content');
            this.orderProcessing = false;
          });
    },

    triggerPageDataPreparation(this:any): void {
      const orderState = this.store.state.order;

      switch (orderState.serviceType) {
        case ServiceTypes.SERVICE_RENT:
          ! orderState.withDriver ? this.handlePageLoadAsRentWithoutDriverService() : this.handlePageLoadAsRentWithDriverService();
          break;

        case ServiceTypes.SERVICE_TRANSPORTATION:
          ! orderState.roundTrip ? this.handlePageLoadAsOneWayTransportationService() : this.handlePageLoadAsRoundTripTransportationService();
          break;
      }
    },

    handlePageLoadAsRentWithoutDriverService(this:any): void {
      axios.post<{
        duration: {
          totalInSec: number,
          hours: number,
          minutes: number
        },
        price: {
          total: number,
          tax_total: number,
          total_tax_percent: number,
          total_tax_charge_rs: number,
          total_currency: number,
        },
      }>(apiService.pageOrderPageLoadAsRentServiceWithoutDriverEndpoint(), {
        serviceType: ServiceTypes.SERVICE_RENT,
        withDriver: false,
        vehicleId: this.store.state.vehicle.selectedVehicle.id,
        mainFormData: {...this.store.state.orderFalseDriver},
      })
          .then((response): void => {
            const data = response.data;

            this.duration = data.duration;
            this.distance = null;

            this.price = parseFloat((data.price.tax_total).toFixed(2));

          })
          .catch(error => {
            this.backendValidationErrors = axiosHelpers.handleAxiosErrors(error, 'key_unprocessable_content');
          });
    },

    handlePageLoadAsRentWithDriverService(this:any): void {
      const state = this.store.state.orderTrueDriver;

      this.duration = state.totalDuration;
      this.distance = state.totalDistance;
      this.price = state.price.toFixed(2);
    },

    handlePageLoadAsOneWayTransportationService(): void {
      const state = this.store.state.orderFalseRoundTrip;

      const transportation = state.transportations.find((item) => item.id === state.transportationId);

      // Duration
      const parts = transportation.travel_time.split(':');

      const hours = parseInt(parts[0]);
      const minutes = parseInt(parts[1]);
      const totalInSec = hours * 60 * 60 + minutes * 60;

      this.duration = {
        totalInSec,
        hours,
        minutes
      };

      this.price = parseFloat((transportation.totals.total * state.tripPassengers * (1 + (transportation.totals.total_tax_percent / 100))).toFixed(2));
    },

    handlePageLoadAsRoundTripTransportationService(this:any): void {

      const state = this.store.state.orderTrueRoundTrip;

      // PRICE
      const forwardPrice = parseFloat((state.forwardTicket.data.totals.total * state.tripPassengers * (1 + (state.forwardTicket.data.totals.total_tax_percent / 100))).toFixed(2));
      const backPrice = parseFloat((state.backTicket.data.totals.total * state.tripPassengers * (1 + (state.backTicket.data.totals.total_tax_percent / 100))).toFixed(2));

      // DURATION
      const forwardDurationInMinutes = parseInt(state.forwardTicket.data.travel_time.split(':')[0]) * 60 + parseInt(state.forwardTicket.data.travel_time.split(':')[1]);
      const backDurationInMinutes = parseInt(state.backTicket.data.travel_time.split(':')[0]) * 60 + parseInt(state.backTicket.data.travel_time.split(':')[1]);

      const totalDuration = forwardDurationInMinutes + backDurationInMinutes;

      const minutes = totalDuration % 60;
      const hours = (totalDuration - minutes) / 60;
      const totalInSec = totalDuration * 60;

      this.price = forwardPrice + backPrice;
      this.duration = {
        totalInSec,
        hours,
        minutes
      };

    },
  },

  created() {},

  mounted() {
    // TODO pass classes as param to the component, not through query selector
    document.querySelector('#buying-company .modal-dialog')?.classList.add('form-modal-width');

    // // Initial load -> load distance, duration, price
    // this.triggerPageDataPreparation();
  }

})
</script>
